import { FC } from 'react'
import styles from './EnergySavings.module.scss'
import { VideoGif } from 'components/basic/VideoGif'

interface EnergySavingsProps {
	title?: string
	description?: string
}

export const EnergySavings: FC<EnergySavingsProps> = (props) => {
	const {
		title = 'Save up to $20/month on your energy bills*',
		description = 'With the Pod, you can save as much as $20/mo* on average by using your AC and heat less. The Pod cools and heats you so efficiently, you may not have to rely on external cooling or heating sources.',
	} = props

	return (
		<section className={`${styles.container} inner-paddings-top`}>
			<h2 className={styles.h2}>{title}</h2>
			<div className={styles.shade}>
				{/* <VideoGif
				src={'https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/Active+Temp+Black.mp4'}
				className={styles.video}
			/> */}
				<VideoGif src="https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/autopilot-earth-animation_comp.mp4" />
			</div>
			<p className={styles.description}>{description}</p>
			<div className={styles.footnote}>* Individual experiences may differ based on house size, ambient and outdoor temperatures, and HVAC type and condition</div>
		</section>
	)
}
